import Cookies from "js-cookie";
import moment from "jalali-moment";
import jwt from "jwt-decode";

import SwiperCore, {
  Autoplay,
  EffectCreative,
  EffectFade,
  Grid,
  Mousewheel,
  Navigation,
  Pagination,
  Parallax,
  Scrollbar,
} from "swiper";
import { base_url } from "../services/configServices/config";

//* Start Cookies
export const getCookies = (name) => {
  return Cookies.get(name);
};

export const removeCookies = (name, path = "/") => {
  return Cookies.remove(name, { path });
};

export const setCookies = (name, value, path = "/") => {
  return Cookies.set(name, value, { path, expires: 7 });
};
//* End Cookies

//* Start Number Utils
export const numberSeparate = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
//* End Number Utils

//* Start JWT Utils
export const decodeJWT = (token) => {
  if (!token) return;
  return jwt(token);
};
//* End JWT Utils

//* Start Themplate Utils
export const scrollAnimation = () => {
  const progress_inner = document.querySelectorAll(".scroll-animate"),
    triggerBottom = (window.innerHeight / 5) * 5 - 20;
  progress_inner.forEach((box) => {
    const boxTop = box.getBoundingClientRect().top;
    if (boxTop < triggerBottom) {
      box.style.visibility = "visible";
      box.classList.add("animate__active");
    }
  });
};

// Sticky nav
export const stickyNav = () => {
  window.addEventListener("scroll", () => {
    let offset = window.scrollY;
    const sticky = document.querySelectorAll(".kf-header");
    for (let i = 0; i < sticky.length; i++) {
      const stick = sticky[i];
      if (stick) {
        if (offset > 10) {
          stick.classList.add("fixed");
        } else {
          stick.classList.remove("fixed");
        }
      }
    }
  });
};
//* End Themplate Utils

//* Start Slider Utils
SwiperCore.use([
  Autoplay,
  EffectCreative,
  EffectFade,
  Grid,
  Mousewheel,
  Navigation,
  Pagination,
  Parallax,
  Scrollbar,
]);
export const sliderProps = {
  mainSliderSelector: {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 1000,
    parallax: true,
    autoplay: {
      delay: 9000,
    },
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    on: {
      progress: function () {
        var swiper = this;
        for (var i = 0; i < swiper.slides.length; i++) {
          var slideProgress = swiper.slides[i].progress,
            innerOffset = swiper.width,
            innerTranslate = slideProgress * innerOffset;
          swiper.slides[i].querySelector(".slide").style.transform =
            "translateX(" + innerTranslate + "px)";
        }
      },
      touchStart: function () {
        var swiper = this;
        for (var i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.transition = "";
        }
      },
      setTransition: function (swiper, speed) {
        for (var i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.transition = speed + "ms";
          swiper.slides[i].querySelector(".slide").style.transition =
            speed + "ms";
        }
      },
    },
  },
  kfGridCarousel: {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,
    speed: 1000,
    watchSlidesProgress: true,
    pagination: false,
    navigation: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      767: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  },
  kfMenuGridCarousel: {
    slidesPerView: 6.3,
    spaceBetween: 0,
    speed: 1000,
    pagination: false,
    navigation: false,
    breakpoints: {
      0: {
        slidesPerView: 1.5,
      },
      370: {
        slidesPerView: 2.2,
      },
      520: {
        slidesPerView: 3.3,
      },
      920: {
        slidesPerView: 4.3,
      },
      1024: {
        slidesPerView: 5.3,
      },
      1200: {
        slidesPerView: 6.3,
      },
    },
  },
  kfTestimonialsCarousel: {
    slidesPerView: 4,
    spaceBetween: 30,
    loop: false,
    speed: 1000,
    watchSlidesProgress: true,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: "true",
    },
    navigation: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      767: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  },
  kfInstaCarousel: {
    slidesPerView: 3,
    spaceBetween: 0,
    loop: true,
    speed: 1000,
    watchSlidesProgress: true,
    pagination: false,
    navigation: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      767: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  },
  kfHistory: {
    slidesPerView: 1,
    spaceBetween: 70,
    loop: false,
    speed: 1000,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: "true",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  },
};

//* End Slider Utils

//* Start Default
export const menuImage = (image, defaultImage) => {
  return base_url + (image ? image : defaultImage);
};
//* End Default

//* Start File
export const validateFile = (file) => {
  if (!file) return;

  const maxSize = 3;
  const allowedExtensions = [
    ".jpg",
    ".jpeg",
    ".png",
    ".gif",
    ".docx",
    ".xlsx",
    ".csv",
    ".pdf",
    ".mp4",
    ".avi",
  ];
  const fileExtension = file.name.split(".").pop();
  if (!allowedExtensions.includes(`.${fileExtension.toLowerCase()}`))
    return "پسوند فایل مورد نظر مجاز نمی باشد";
  if (file.size > maxSize * 1024 * 1024)
    return `حجم فایل نمی تواند بیشتر از ${maxSize} مگابایت باشد`;
};
//* End File

//* Start Notification Sound
export const playNotificationSound = async () => {
  let soundName = "/assets/sound/notification.wav";

  const audio = new Audio(soundName);

  try {
    await audio.play();
  } catch (error) {
    // error
  }
};
//* End Notification Sound

//* Start Date Utils
export const convertDate = (date, format = "YYYY/MM/DD", locale = "fa") => {
  if (!date || date === "0001-01-01T00:00:00") return "-";
  return moment(date).locale(locale).format(format);
};
export const calculateTotalHours = (
  startDate,
  endDate,
  hoursPerDay,
  callback,
) => {
  if (!startDate || !endDate || !hoursPerDay) return;

  const dayPerMillisecond = 86_400_000;
  const day = (endDate - startDate) / dayPerMillisecond + 1;
  if (day <= 0) return;

  if (callback) callback(day * hoursPerDay);
};
//* End Date Utils
